"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicEventSuccessType = exports.DynamicEventRarity = void 0;
var DynamicEventRarity;
(function (DynamicEventRarity) {
    DynamicEventRarity["Common"] = "common";
    DynamicEventRarity["Uncommon"] = "uncommon";
    DynamicEventRarity["Rare"] = "rare";
    DynamicEventRarity["Legendary"] = "legendary";
})(DynamicEventRarity || (exports.DynamicEventRarity = DynamicEventRarity = {}));
var DynamicEventSuccessType;
(function (DynamicEventSuccessType) {
    DynamicEventSuccessType["Kills"] = "kills";
})(DynamicEventSuccessType || (exports.DynamicEventSuccessType = DynamicEventSuccessType = {}));
